import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import ProductPrice from '../ProductPrice';
var useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  productPrice: {}
}, {
  name: 'SxComProductDetailPrice'
});

function ProductDetailPrice(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? ProductPrice : _ref$component,
      currency = _ref.currency,
      DiscountProps = _ref.DiscountProps,
      discountVariant = _ref.discountVariant,
      product = _ref.product,
      ProductPriceProps = _ref.ProductPriceProps,
      renderToGridArea = _ref.renderToGridArea,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "component", "currency", "DiscountProps", "discountVariant", "product", "ProductPriceProps", "renderToGridArea"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement(GridAreaContainer, _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className),
    renderToGridArea: renderToGridArea
  }), /*#__PURE__*/React.createElement(Component, _extends({
    className: classes.productPrice,
    currency: currency,
    product: product,
    discountVariant: discountVariant,
    DiscountProps: DiscountProps
  }, ProductPriceProps), children));
}

ProductDetailPrice.propTypes = {
  children: PropTypes.func,
  classes: PropTypes.shape({
    productPrice: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  component: PropTypes.elementType,
  currency: PropTypes.string.isRequired,
  // ISO kod meny (CZK, EUR...)
  DiscountProps: PropTypes.shape({
    DiscountLabelProps: PropTypes.shape({}),
    DiscountOriginalPriceProps: PropTypes.shape({})
  }),
  discountVariant: PropTypes.oneOf(['percent', 'amount']),
  product: PropTypes.shape({}).isRequired,
  ProductPriceProps: PropTypes.shape({}),
  renderToGridArea: PropTypes.string // konecna cena, pokud neni definovana, pouzije se listPrice

};
ProductDetailPrice.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  component: undefined,
  DiscountProps: undefined,
  discountVariant: undefined,
  ProductPriceProps: undefined,
  renderToGridArea: 'price'
};
export default ProductDetailPrice;